"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchMonthFormatOptions = exports.fetchDateTimeFormatOptions = exports.createCustomDateTimeFormatOption = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _of = require("rxjs/observable/of");

var _reduxObservable = require("redux-observable");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var createCustomDateTimeFormatOption = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createCustomDateTimeFormatOption,
  initiatingActionType: _actions.LanguageActionTypes.CREATE_CUSTOM_DATE_TIME_FORMAT_OPTION,
  requestStatusSelector: _selectors.getCreateCustomDateTimeFormatRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateCustomDateTimeFormatOption
}));
exports.createCustomDateTimeFormatOption = createCustomDateTimeFormatOption;

var fetchDateTimeFormatOptions = function fetchDateTimeFormatOptions($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.LanguageActionTypes.LOAD_DATETIME_FORMAT_OPTIONS).pipe((0, _filter.filter)(function (action) {
    var _action$payload = action.payload,
        language = _action$payload.language,
        selected = _action$payload.selected;
    return (0, _selectors.getFetchDateTimeFormatOptionsRequestStatus)(language, selected)(getState()) === _RequestStatusTypes.default.UNINITIALIZED;
  }), (0, _mergeMap.mergeMap)(function (action) {
    var _action$payload2 = action.payload,
        language = _action$payload2.language,
        selected = _action$payload2.selected;
    return (0, _fromPromise.fromPromise)(_API.default.getDateTimeFormatOptions(language, selected)).pipe((0, _map.map)(function (response) {
      return _actions.FetchDateTimeFormatOptions.success(response, {
        language: language,
        selected: selected
      });
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchDateTimeFormatOptions.failure(error, {
        language: language,
        selected: selected
      }));
    }), (0, _startWith.startWith)(_actions.FetchDateTimeFormatOptions.request({
      language: language,
      selected: selected
    })));
  }));
};

exports.fetchDateTimeFormatOptions = fetchDateTimeFormatOptions;

var fetchMonthFormatOptions = function fetchMonthFormatOptions($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions.LanguageActionTypes.LOAD_MONTH_FORMAT_OPTIONS).pipe((0, _filter.filter)(function (action) {
    var _action$payload3 = action.payload,
        language = _action$payload3.language,
        selected = _action$payload3.selected;
    return (0, _selectors.getFetchMonthFormatOptionsRequestStatus)(language, selected)(getState()) === _RequestStatusTypes.default.UNINITIALIZED;
  }), (0, _mergeMap.mergeMap)(function (action) {
    var _action$payload4 = action.payload,
        language = _action$payload4.language,
        selected = _action$payload4.selected;
    return (0, _fromPromise.fromPromise)(_API.default.getMonthFormatOptions(language, selected)).pipe((0, _map.map)(function (response) {
      return _actions.FetchMonthFormatOptions.success(response, {
        language: language,
        selected: selected
      });
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchMonthFormatOptions.failure(error, {
        language: language,
        selected: selected
      }));
    }), (0, _startWith.startWith)(_actions.FetchMonthFormatOptions.request({
      language: language,
      selected: selected
    })));
  }));
};

exports.fetchMonthFormatOptions = fetchMonthFormatOptions;

var _default = (0, _reduxObservable.combineEpics)(createCustomDateTimeFormatOption, fetchDateTimeFormatOptions, fetchMonthFormatOptions);

exports.default = _default;